import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/quotations/logistics/providers`;

/**
 * Proveedores logísticos. El código de 2 dígitos forma parte del correlativo del
 * viaje (TRPYY-ZZXXX), por eso se asigna al crear y no se edita después.
 */
export const logisticsProvidersAPI = {
  async getAll({ includeInactive = false } = {}) {
    return apiClient(`${BASE}${includeInactive ? '?include_inactive=true' : ''}`);
  },

  async getNextCode() {
    return apiClient(`${BASE}/next-code`);
  },

  async create(data) {
    return apiClient(BASE, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(code, data) {
    return apiClient(`${BASE}/${code}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  /** Desactiva el proveedor: los viajes históricos conservan su código. */
  async remove(code) {
    return apiClient(`${BASE}/${code}`, { method: 'DELETE' });
  },
};

export default logisticsProvidersAPI;
